exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-log {\n  font-size: 23px;\n  border-radius: 9px;\n  background-color: #f4f4f4;\n  padding: 1em;\n  border: solid 1px #b5b5b5; }\n  .activity-log .title {\n    text-align: center;\n    padding-top: 1em;\n    font-weight: 500; }\n  .activity-log .no-history {\n    font-size: 15px;\n    margin-top: 30px;\n    text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Status/components/SyncPanel/components/scss/activityLog.scss
// module id = 911
// module chunks = 1